import User from 'cvat-core/src/user';
import { Task } from 'reducers';

const priorities: Record<string, number> = {
    admin: 0,
    business: 50,
    user: 75,
    worker: 100,
};

export function hasPermissionForJobAfterInspectionStage(user: User): boolean {
    for (const group of user.groups) {
        if (priorities[group] <= priorities.business) {
            return true;
        }
    }
    return false;
}

export function hasPermissionForJobAfterQualityCtlStage(user: User): boolean {
    for (const group of user.groups) {
        if (priorities[group] <= priorities.admin) {
            return true;
        }
    }
    return false;
}

export function hasAdminPermission(user: User): boolean {
    return hasPermissionForJobAfterQualityCtlStage(user);
}

export function hasPermissionToChangeTaskAuditor(user: User, task: Task): boolean {
    if (user.isSuperuser) {
        return true;
    }
    if (user.id === task.owner?.id || user.id === task.assignee?.id || user.id === task.supervisor?.id) {
        return true;
    }
    return false;
}
